import { useState } from 'react';
import AppLayout from '../../components/AppLayout';

import { FaTrashAlt } from 'react-icons/fa';

import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import RHFInput from '../../components/RHF/RHFInput';
import { RHFSubmitButton } from '../../components/RHF/RHFSubmitButton';
import { useUserDetails } from '../../helpers/UserContext';
import AuthApi from '../../apis/AuthApi';
import { toast } from 'react-toastify';
import { clearToken } from '../../apis/LocalStorageApi';
import { handleError } from '../../apis';

const validator_delete = z.object({
  password: z
    .string('Required!')
    .trim()
    .min(6, { message: 'Password must be at least 6 characters long' })
    .refine(
      (value) => /[a-z]/.test(value),
      'Password must contain a lowercase character',
    )
    .refine(
      (value) => /[A-Z]/.test(value),
      'Password must contain a uppercase character',
    )
    .refine(
      (value) => /[!@#$%^&*]/.test(value),
      'Password must contain a special character (!@#$%^&*)',
    )
    .refine((value) => /\d/.test(value), 'Password must contain a number'),
});

export default function Settings() {
  const [, setUserDetails] = useUserDetails();
  const [isOpen, setIsOpen] = useState(false);
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: zodResolver(validator_delete),
  });

  const onHandleSubmit = async (values: z.infer<typeof validator_delete>) => {
    try {
      const res = await AuthApi.deleteUser(values);
      if (res.message === 'Password is incorrect') {
        toast.error('Password is incorrect');
        return;
      }
      if (res.message === 'DELETED') {
        clearToken();
        setUserDetails(null);
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
      const message = handleError(error);
      toast.error(message);
    }
  };

  const downloadData = async () => {
    try {
      const response = await AuthApi.downloadData();
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'AlpacaTrackerExport.xlsx');
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
    } catch (error) {
      console.log(error);
      const message = handleError(error);
      toast.error(message);
    }
  };
  return (
    <AppLayout>
      <div className='mb-8 w-full'>
        <div className='flex items-start justify-center'>
          <h3 className='text-center text-2xl dark:text-gray-300'>Settings</h3>
        </div>
        <div className='m-auto max-w-[600px]'>
          <div className='flex items-center justify-center py-4'>
            {/* <Link to='/export' reloadDocument download> */}
            <button
              type='button'
              onClick={downloadData}
              className='my-2 w-full max-w-[275px] rounded-md border border-slate-950 bg-transparent p-2 text-xs font-bold uppercase hover:border-gray-400 hover:text-gray-400 dark:border-gray-500 dark:hover:border-gray-300 dark:hover:text-gray-300'
            >
              Download All Data
            </button>
            {/* </Link> */}
          </div>
          {/* <p className='p-1'>Email: {loaderData.user.email}</p>
          <div className='p-1'>
            <div
              id='accordion-open'
              data-accordion='open'
              className='my-1 mb-4'
            >
              <h2 id='accordion-open-heading-1' className='m-0'>
                <Form preventScrollReset>
                  <button
                    type='submit'
                    name='edit'
                    value={edit === 'name' ? 'none' : 'name'}
                    className={`flex w-full items-center justify-between gap-3  border ${
                      edit === 'name'
                        ? 'rounded-b-none rounded-t-lg border-b-0'
                        : 'rounded-lg'
                    } g-gray-50  block w-full  rounded-lg border border-gray-300 p-2.5
              text-sm text-gray-900 focus:border-gray-400 focus:ring-gray-400
               dark:border-0 dark:bg-gray-700 dark:text-gray-400 dark:placeholder-gray-400 dark:focus:ring-gray-400`}
                    data-accordion-target='#accordion-open-body-1'
                    aria-expanded={edit === 'name'}
                    aria-controls='accordion-open-body-1'
                  >
                    <span className='flex items-center justify-center tracking-wide'>
                      Name: {loaderData.user?.firstName}{' '}
                      {loaderData.user.lastName}
                      <FaEdit className='ms-4' />
                    </span>
                    <svg
                      data-accordion-icon
                      className='h-3 w-3 shrink-0 rotate-180'
                      aria-hidden='true'
                      xmlns='http://www.w3.org/2000/svg'
                      fill='none'
                      viewBox='0 0 10 6'
                    >
                      <path
                        stroke='currentColor'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        strokeWidth='2'
                        d='M9 5 5 1 1 5'
                      />
                    </svg>
                  </button>
                </Form>
              </h2>

              <div
                id='accordion-open-body-1'
                className={`${edit === 'name' ? 'block' : 'hidden'}`}
                aria-labelledby='accordion-open-heading-1'
              >
                <div className='rounded-b-lg border border-gray-200 p-4 dark:border-gray-700 dark:bg-gray-900'>
                  <div className='max-w-[600px]'>
                    <ValidatedForm
                      validator={validator_edit_name}
                      defaultValues={loaderData.user}
                      method='post'
                    >
                      <div>
                        <RVFInput
                          name='firstName'
                          type='text'
                          label='First Name'
                        />
                        <RVFInput
                          name='lastName'
                          type='text'
                          label='Last Name'
                        />
                        <div className='flex justify-evenly gap-4'>
                          <button
                            type='button'
                            onClick={() =>
                              navigate('?edit=none', {
                                preventScrollReset: true,
                              })
                            }
                            className='my-2 w-full max-w-[275px] rounded-md border border-slate-950 bg-transparent p-2 text-xs font-bold uppercase hover:border-gray-400 hover:text-gray-400 dark:border-gray-500 dark:hover:border-gray-300 dark:hover:text-gray-300'
                          >
                            Cancel
                          </button>
                          <RVFSubmitButton label='Submit' />
                        </div>
                      </div>
                    </ValidatedForm>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          <div className='p-1'>
            <div
              id='accordion-delete-open'
              data-accordion='open'
              className='my-1 mb-4'
            >
              <h2 id='accordion-delete-open-heading-1' className='m-0'>
                <button
                  type='button'
                  name='edit'
                  onClick={() => setIsOpen(!isOpen)}
                  className={`flex w-full items-center justify-between gap-3  border ${
                    isOpen
                      ? 'rounded-b-none rounded-t-lg border-b-0'
                      : 'rounded-lg'
                  } g-gray-50  block w-full  rounded-lg border border-gray-300 p-2.5
              text-sm text-gray-900 focus:border-gray-400 focus:ring-gray-400
               dark:border-0 dark:bg-gray-700 dark:text-gray-400 dark:placeholder-gray-400 dark:focus:ring-gray-400`}
                  data-accordion-target='#accordion-open-body-1'
                  aria-expanded={isOpen}
                  aria-controls='accordion-open-body-1'
                >
                  <span className='flex items-center justify-center tracking-wide text-rose-600 dark:text-rose-400'>
                    Delete Account
                    <FaTrashAlt className='ms-4' />
                  </span>
                  <svg
                    data-accordion-icon
                    className='h-3 w-3 shrink-0 rotate-180'
                    aria-hidden='true'
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 10 6'
                  >
                    <path
                      stroke='currentColor'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M9 5 5 1 1 5'
                    />
                  </svg>
                </button>
              </h2>

              <div
                id='accordion-open-body-1'
                className={`${isOpen ? 'block' : 'hidden'}`}
                aria-labelledby='accordion-open-heading-1'
              >
                <div className='rounded-b-lg border border-gray-200 p-4 dark:border-gray-700 dark:bg-gray-900'>
                  <div className='max-w-[600px]'>
                    <p>
                      This will delete your account and all data, CAN NOT BE
                      UNDONE!
                    </p>
                    <form onSubmit={handleSubmit(onHandleSubmit)}>
                      <div>
                        <RHFInput
                          name='password'
                          type='password'
                          label='Password'
                          register={register('password')}
                          errors={errors}
                        />

                        <div className='flex justify-evenly gap-4'>
                          <button
                            type='button'
                            onClick={() => {
                              reset();
                              setIsOpen(false);
                            }}
                            className='my-2 w-full max-w-[275px] rounded-md border border-slate-950 bg-transparent p-2 text-xs font-bold uppercase hover:border-gray-400 hover:text-gray-400 dark:border-gray-500 dark:hover:border-gray-300 dark:hover:text-gray-300'
                          >
                            Cancel
                          </button>
                          <RHFSubmitButton
                            label='Submit'
                            isSubmitting={isSubmitting}
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  );
}
